export type HistoryType =
  // 운영 이력
  | 'inbound'      // 입고
  | 'outbound'     // 출고
  | 'production'   // 일일생산량
  | 'trial_production'  // 시사출
  // 관리 이력
  | 'maintenance'  // 정기 정비
  | 'repair'       // 긴급 수리
  | 'inspection'   // 점검
  | 'modification' // 개조/개선
  | 'accident'     // 사고/파손
  | 'disposal'     // 폐기
  | 'other';       // 기타

export const HISTORY_TYPE_LABELS: Record<HistoryType, string> = {
  inbound: '입고',
  outbound: '출고',
  production: '일일생산량',
  trial_production: '시사출',
  maintenance: '정기 정비',
  repair: '긴급 수리',
  inspection: '점검',
  modification: '개조/개선',
  accident: '사고/파손',
  disposal: '폐기',
  other: '기타',
};

export interface HistoryFile {
  id: string;
  name: string;
  url: string;
  type: 'image' | 'document';
  size: number;
  uploadedAt: Date;
}

export interface MoldHistory {
  id?: string;
  moldId: string;
  moldNumber: string;  // 검색/표시용
  moldName?: string;   // 표시용
  
  type: HistoryType;
  title: string;
  description: string;
  date: Date;
  
  // 출고/입고 관련
  shots?: number;
  purpose?: string;
  expectedReturn?: Date;
  actualReturn?: Date;
  
  // 생산 관련
  productionQty?: number;
  defectQty?: number;
  selectedCavities?: number[];  // 사용된 캐비티 번호들
  
  // 정비/수리/개조 관련
  cost?: number;
  vendor?: string;
  
  // 점검 관련
  inspector?: string;
  inspectionResult?: 'normal' | 'abnormal';
  
  // 폐기 관련
  disposalReason?: string;
  disposalMethod?: string;
  
  // 파일 첨부
  files?: HistoryFile[];
  
  // 메타 정보
  userId: string;
  userName?: string;  // 표시용
  createdAt: Date;
  updatedAt: Date;
}

export interface HistoryFilter {
  moldId?: string;
  type?: HistoryType;
  startDate?: Date;
  endDate?: Date;
  searchText?: string;
}

export interface HistoryFormData {
  moldId: string;
  type: HistoryType;
  title: string;
  description: string;
  date: Date;
  shots?: number;
  purpose?: string;
  expectedReturn?: Date;
  productionQty?: number;
  defectQty?: number;
  selectedCavities?: number[];  // 사용된 캐비티 번호들
  cost?: number;
  vendor?: string;
  inspector?: string;
  inspectionResult?: 'normal' | 'abnormal';
  disposalReason?: string;
  disposalMethod?: string;
  files?: File[];
}
